module.exports = __webpack_public_path__ + "img/Noresult3.52684402.png";